class utils {
  formatDate({ dateString, format, dbdate = false, includeTime = false }) {
    if (!dateString) {
      return null;
    }

    let year, month, day, hours, minutes, seconds;

    if (dbdate) {
      // Assume the database date format is always in 'YYYY-MM-DDTHH:MM:SSZ' format
      const parts = dateString.split('T');
      [year, month, day] = parts[0].split('-');

      if (includeTime && parts.length > 1) {
        [hours, minutes, seconds] = parts[1].split(':');
        seconds = seconds.split('Z')[0]; // Remove 'Z' from the end of the seconds part
      } else {
        hours = '00';
        minutes = '00';
        seconds = '00';
      }
    } else {
      // Handle other date formats
      const separator = dateString?.includes('/') ? '/' : '-';
      [day, month, year] = dateString?.split(separator);

      // Ensure the year is four digits for non-DB dates
      if (year.length === 2) {
        year = '20' + year; // Assuming 21st century for two-digit year
      }

      // Get current time if includeTime is true
      if (includeTime) {
        const now = new Date();
        hours = String(now.getHours()).padStart(2, '0');
        minutes = String(now.getMinutes()).padStart(2, '0');
        seconds = String(now.getSeconds()).padStart(2, '0');
      } else {
        hours = '00';
        minutes = '00';
        seconds = '00';
      }
    }

    // Create a date parts object
    const dateParts = { day, month, year };

    // Mapping output formats to template literals
    const formatMapping = {
      'dd/mm/yyyy': `${dateParts.day}/${dateParts.month}/${dateParts.year}`,
      'mm/dd/yyyy': `${dateParts.month}/${dateParts.day}/${dateParts.year}`,
      'yyyy/mm/dd': `${dateParts.year}/${dateParts.month}/${dateParts.day}`,
      'dd-mm-yyyy': `${dateParts.day}-${dateParts.month}-${dateParts.year}`,
      'mm-dd-yyyy': `${dateParts.month}-${dateParts.day}-${dateParts.year}`,
      'yyyy-mm-dd': `${dateParts.year}-${dateParts.month}-${dateParts.day}`,
      'dd/mm/yy': `${dateParts.day}/${dateParts.month}/${dateParts.year.slice(-2)}`
    };

    // Format the date
    const lowerFormat = format.toLowerCase();
    if (!formatMapping[lowerFormat]) {
      throw new Error('Unsupported date format');
    }
    let formattedDate = formatMapping[lowerFormat];

    // Append time if required
    if (includeTime) {
      formattedDate += ` ${hours}:${minutes}:${seconds}`;
    }

    return formattedDate;
  }

  getCurrentDateFormatted(format = 'MM/DD/YYYY', includeTime = false) {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month and pad with zero if needed (months are zero-based)
    const year = date.getFullYear(); // Get full year

    const hours = String(date.getHours()).padStart(2, '0'); // Get hours and pad with zero if needed
    const minutes = String(date.getMinutes()).padStart(2, '0'); // Get minutes and pad with zero if needed
    const seconds = String(date.getSeconds()).padStart(2, '0'); // Get seconds and pad with zero if needed

    let formattedDate;

    switch (format) {
      case 'MM/DD/YYYY':
        formattedDate = `${month}/${day}/${year}`;
        break;
      case 'DD/MM/YYYY':
        formattedDate = `${day}/${month}/${year}`;
        break;
      case 'YYYY-MM-DD':
        formattedDate = `${year}-${month}-${day}`;
        break;
      case 'YYYY/MM/DD':
        formattedDate = `${year}/${month}/${day}`;
        break;
      case 'DD-MM-YYYY':
        formattedDate = `${day}-${month}-${year}`;
        break;
      case 'MM-DD-YYYY':
        formattedDate = `${month}-${day}-${year}`;
        break;
      default:
        formattedDate = `${month}/${day}/${year}`; // Default to MM/DD/YYYY
    }

    if (includeTime) {
      formattedDate += ` ${hours}:${minutes}:${seconds}`;
    }

    return formattedDate;
  }
  validateTextFieldCodeforAddress(text) {
    const pattern = /^[a-zA-Z0-9\/-><?_)(*&^%$#@!)+=',.\-{}\[\]|\\ ]+$/; // Allow single space
    return pattern.test(text);
  };
  validateTextFieldCode(text) {
    const pattern = /^[a-zA-Z0-9/-]+$/;
    return pattern.test(text);
  };

  validateTextField(text) {
    const pattern = /^(?! )[a-zA-Z0-9,/!@#$%&*()'_.-]+(?: [a-zA-Z0-9/,!@#$%&*()'_.-]+)* ?$/;
    return pattern.test(text);
  }

  validateEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  validatePhoneNumber(phoneNumber) {
    var regex = /^\+?[0-9]{1,3}?[-\s\.]?(\([0-9]+\)|[0-9]+(\.?[0-9]+)*)$/;
    return regex.test(phoneNumber);
  }
  validatePrice(price) {
    const regex = /^\d+(\.\d{1,2})?$/;
    return regex.test(price);
  }
  //   validateTextFieldCode(text) {
  //   const pattern = /^(?! )[a-zA-Z0-9/-]+(?: [a-zA-Z0-9/-]+)*$/; // Updated pattern
  //   return pattern.test(text) && text[text.length - 1] !== ' ';
  // }
  

     validateUserId(text) {
const pattern = /^(?! )[a-zA-Z0-9_'"`:?><.!@#$%^&*()/\-]+(?: [a-zA-Z0-9_'"`:?><.!@#$%^&*()/\-]+)*$/;
    return pattern.test(text);
  }

  validateEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }
    validatePhoneNumber(phoneNumber) {
    var regex = /^(\+?[0-9]{1,4}[\s\-]?)?(\(?[0-9]{1,3}\)?[\s\-]?)?([0-9]{1,4}[\s\-]?[0-9]{1,4}[\s\-]?[0-9]{1,4})$/;
    return regex.test(phoneNumber);
  }
    validatePrice(price) {
    const regex = /^\d+(\.\d{1,2})?$/;
    return regex.test(price);
  }

  validateNumberOnly(phoneNumber) {
    var regex = /^\+?[0-9]+$/;
    return regex.test(phoneNumber);
  }



  // DATE COMPARATOR FOR SORTING
  dateComparator(date1, date2) {
    var date1Number = this._monthToNum(date1);
    var date2Number = this._monthToNum(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  // HELPER FOR DATE COMPARISON
  _monthToNum(date) {
    if (date === undefined || date === null || date.length !== 10) {
      return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
  }

  workRequestDateTime(inputDateTimeStr) {
    const datetime = new Date(inputDateTimeStr);

    if (isNaN(datetime)) {
      return null;
    }

    const padTwoDigits = (number) => number.toString().padStart(2, '0');

    const day = padTwoDigits(datetime.getDate());
    const month = padTwoDigits(datetime.getMonth() + 1);
    const year = datetime.getFullYear();
    const hours = padTwoDigits(datetime.getHours());
    const minutes = padTwoDigits(datetime.getMinutes());
    const seconds = "00"; // Set seconds explicitly to "00"

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    //return datetime.toISOString();
  }

  getExtensionFromContentType(contentType) {
    switch (contentType) {
      case 'application/msword':
        return '.doc';
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return '.docx';
      case 'image/jpeg':
      case 'image/jpg':
        return '.jpg';
      case 'image/png':
        return '.png';
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return '.xlsx';
      case 'text/csv':
        return '.csv';
      case 'application/pdf':
        return '.pdf';
      // Add more content types and extensions as needed
      default:
        console.warn(`Unknown content type: ${contentType}`);
        return ''; // No extension if unknown
    }
  };

  refreshGrid = (gridApi) => {
    gridApi.setFilterModel(null);
    gridApi.paginationProxy.setPageSize(10, "pageSizeSelector");
    const columns = gridApi.getColumns();
    const hiddenColumns = columns.filter((column) => !column.visible);
    hiddenColumns.forEach((column) => {
      gridApi.setColumnVisible(column, true);
    });
    gridApi.refreshHeader();
  };

  getRecentSixMonths = () => {
    const monthLabels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const now = new Date();
    const currentMonthIndex = now.getMonth(); // 0-based index for current month
    const currentYear = now.getFullYear(); // Current full year

    const recentMonths = [];

    for (let i = 0; i < 6; i++) {
      // Calculate month index (wrap around with modulus)
      const monthIndex = (currentMonthIndex - i + 12) % 12;

      // Determine the year: if we're moving backwards past January, we subtract from the year
      const year = currentMonthIndex - i < 0 ? currentYear - 1 : currentYear;

      // Add the formatted month and year (last two digits of the year)
      recentMonths.push({
        label: `${monthLabels[monthIndex]}-${String(year).slice(2)}`, // Last two digits of the year
        id: String(monthIndex + 1).padStart(2, '0') // Month as 2-digit number (01, 02, etc.)
      });
    }

    // Reverse to get chronological order (earliest to latest)
    return recentMonths.reverse();
  };


  getScreenPermissions = (accessData, screenCode) => {
    // Check if accessData and accessData.accessData are valid
    if (!accessData || !accessData.accessData) {
      // console.error("Invalid accessData");
      return null;
    }

    // Find the object in accessData that matches the provided screenCode
    const screenAccess = accessData.accessData.find(item => item.transCode === screenCode);

    // Check if the screenAccess object was found
    if (!screenAccess) {
      // console.error(`Screen code ${screenCode} not found`);
      return null;
    }

    // Extract the accessString (permission field)
    const accessString = screenAccess.permission;

    // Now, map the accessString to permissions object
    const getPermissionsObject = (accessString) => {
      return {
        canCreate: accessString[0] === '1',
        canEdit: accessString[1] === '1',
        canDelete: accessString[2] === '1',
        canView: accessString[3] === '1',
        canAuthorize: accessString[4] === '1',
        canClose: accessString[5] === '1',
        canPrint: accessString[6] === '1',
        canPost: accessString[7] === '1',
        canCancel: accessString[8] === '1',
        canApprove: accessString[9] === '1',
        canAmend: accessString[10] === '1',
        canOrder: accessString[11] === '1',
        // Add more permissions based on the accessString length and positions
      };
    };

    // Return the permissions object by passing the accessString
    return getPermissionsObject(accessString);
  };

  compareDates = (fromDate, toDate) => {
    // Helper function to parse DD/MM/YYYY to a Date object
    const parseDate = (dateStr) => {
      const [day, month, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day); // Month is zero-based in JavaScript
    };

    const parsedFromDate = parseDate(fromDate);
    const parsedToDate = parseDate(toDate);

    return parsedFromDate <= parsedToDate;
  };



}
export default new utils()

